<ng-container *ngIf="vm$ | async as vm">
	<ng-template #createNewTemplate let-item>
		<div class="flex justify-between">
			<span class="mr-3 whitespace-nowrap">{{ financialInstitutionName }}</span>
			<app-button
				[icon]="ICON.ADD"
				size="small"
				[cssClasses]="['button', 'text-xs']"
				>Create new lender</app-button
			>
		</div>
	</ng-template>

	<ng-template #institutionTemplate let-item>
		<div class="flex gap-2">
			<span class="whitespace-nowrap p-sm"
				>{{ item.name | capitalize }} | {{ item.number }}</span
			>
		</div>
	</ng-template>

	<div>
		<div *ngIf="!labelTemplate">
			{{ label }}
			<span class="asterix" *ngIf="required">*</span>
		</div>
		<ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
		<div>
			<p class="p-xs pb-2">Quick Select</p>
			<div class="flex gap-2 mb-4">
				<div
					*ngFor="let bank of popularLenders"
					class="py-2 px-3 rounded-md hover:bg-gray-50 cursor-pointer duration-300 flex items-center justify-center w-24"
					[ngClass]="{
						'bg-gray-100': vm.selectedInstitution?.id === bank.institutionId,
					}"
					(click)="setLeadingBank(bank.institutionId)"
				>
					<img [src]="'/assets/images/banks/' + bank.logo" />
				</div>
			</div>
		</div>
		<div *ngIf="mortgageeType === mortgageeTypes.INSTITUTION">
			<ng-container *ngIf="!vm.selectedInstitution; else selectedInstitution">
				<app-auto-complete
					(onSelect)="onSelect($event)"
					placeholder="Select a financial institution"
					[required]="true"
					[itemGroups]="[
						{
							items: (financialInstitutions$ | async),
							template: institutionTemplate,
							noResultsMessage: 'No lender found',
							type: dropdownSelect.SELECT_INSTITUTION,
						},
					]"
					[(ngModel)]="financialInstitutionName"
					name="dual-dropdown-1"
					(debounce)="search($event)"
					[loading]="loading"
					width="w-full"
				>
				</app-auto-complete>
			</ng-container>
		</div>
	</div>

	<ng-template #selectedInstitution>
		<div
			class="flex gap-2 justify-between items-center py-1 px-3 pr-1 border rounded-md"
		>
			<div class="flex gap-2">
				<span class="whitespace-nowrap p-sm"
					>{{ vm.selectedInstitution?.name | capitalize }}
					|
					{{ vm.selectedInstitution?.institutionNumber }}</span
				>
			</div>
			<ui-button
				icon="x"
				preset="ICON_DEFAULT"
				size="sm"
				(click)="clearBank()"
			/>
		</div>
	</ng-template>
</ng-container>
